// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6864":"css/admin-app.6701","8425":"css/app.6701"}[chunkId] + ".css";
};